import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useGetBankAccounts = () => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour
    queryKey: [QUERY_KEYS.cash.bank_accounts],
    queryFn: () =>
      cashService.bankAccounts().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
